import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import {
  AppstoreAddOutlined,
  MailOutlined,
  CustomerServiceOutlined,
  SettingOutlined,
  PayCircleOutlined,
  ContactsOutlined,
  SnippetsOutlined,
} from '@ant-design/icons';
import './headerWrapper.scss';
import { Paragraph } from 'components/atoms/index';

const items = [
  {
    label: 'HOME',
    key: 'home',
    icon: <AppstoreAddOutlined />,
    refname: {
      name: 'ImageTrackRef',
      path: '/',
    },
  },
  {
    label: 'SERVICES',
    key: 'services',
    icon: <CustomerServiceOutlined />,
    refname: {
      name: 'ServicesRef',
      path: '/',
    },
  },
  {
    label: 'ABOUT',
    key: 'about',
    icon: <SnippetsOutlined />,
    refname: {
      name: 'AboutRef',
      path: '/',
    },
  },
  {
    label: 'BENEFITS',
    key: 'benefit',
    icon: <SettingOutlined />,
    refname: {
      name: 'BenefitRef',
      path: '/',
    },
  },
  {
    label: 'CONTACT',
    key: 'contact',
    icon: <ContactsOutlined />,
    refname: {
      name: 'ContactRef',
      path: '/',
    },
  },
  {
    label: 'SETUP',
    key: 'setup',
    icon: <MailOutlined />,
    refname: {
      name: 'Setup',
      path: '/setup',
    },
  },
  {
    label: 'PAY INVOICE',
    key: 'payInvoice',
    icon: <PayCircleOutlined />,
    refname: {
      name: 'Pay',
      path: '/pay',
    },
  },
];

const Header = ({ refsList, history, location }) => {
  const [current, setCurrent] = useState('home');

  const changeMenu = e => {
    const item = items.filter(el => el.key === e.key)?.[0];
    const { name, path } = item.refname;
    // if (
    //   !['/pay', '/setup', '/privacy-policy', '/terms-and-conditions'].includes(location.pathname) &&
    //   !['Setup', 'Pay'].includes(name)
    // ) {
    //   refsList[name]?.current?.scrollIntoView({
    //     behavior: 'smooth',
    //     block: 'start',
    //   });
    //   setCurrent(e.key);
    // } else {
    history.push({ pathname: path, state: { name, key: e.key } });
    //  / }
  };

  useEffect(() => {
    if (!location?.state?.key) setCurrent(false);
    else setCurrent(location.state.key);
  }, [location?.state]);

  return (
    <div className='header_conatiner'>
      <div className='header_content'>
        <div className='header_logo'>
          <Paragraph fz={25} mb={0} fw={900} color='black'>
            MOVEBO GROUP
          </Paragraph>
        </div>
        <div className='header_items_content'>
          {items.map(el => {
            return (
              <div key={el.key} className={current === el.key ? 'menu_selected_item' : ' '}>
                {el.icon}
                <div onClick={() => changeMenu(el)}>{el.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default withRouter(Header);
